<div class="row" [style.display]="state.value === 'inactive' ? 'none' : ''" data-cy="toast-msg-container">
  <div class="col-9">
    @if (title) {
      <div [class]="options.titleClass" [attr.aria-label]="title">
        {{ title | translate }}
      </div>
    }
    @if (message && !options.enableHtml) {
      <div
        role="alert"
        [class]="options.messageClass"
        [attr.aria-label]="message"
        [ngClass]="{ 'message-only': !title }"
        >
        {{ message | translate }} {{ options.payload?.suffix ?? '' }}
      </div>
    }
  </div>
  <div class="col-3 text-right">
    @if (options.closeButton) {
      <a
        tabindex="0"
        (keydown.enter)="remove()"
        (keydown.space)="remove()"
        (click)="remove()"
        class="btn btn-sm"
        >
        close
      </a>
    }
  </div>
</div>
@if (options.progressBar) {
  <div>
    <div class="toast-progress" [style.width]="width + '%'"></div>
  </div>
}